import { Link } from "react-router-dom";

const stats = [
  { value: "1,280+", label: "影视作品收录" },
  { value: "640+", label: "深度影评" },
  { value: "36", label: "编辑专题" },
  { value: "2026", label: "持续更新中" },
];

export default function AboutStrip() {
  return (
    <section className="bg-primary-950 text-background-50">
      <div className="mx-auto grid w-full max-w-[1400px] grid-cols-1 gap-10 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="mb-3 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-accent-400">
            <span className="h-1 w-5 rounded-full bg-accent-500" />
            About 疯狂的欲望
          </span>
          <h2 className="font-heading text-2xl font-bold leading-snug md:text-3xl">
            我们不只告诉你「看什么」，更想陪你想清楚「为什么值得看」
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-300">
            「疯狂的欲望」是一个专注影视内容的资讯门户。我们追踪最新电影与电视剧的动态，整理完整剧情脉络与演员阵容，并邀请影评人撰写有观点的深度分析，帮助每一位影视爱好者在浩瀚片单中，找到真正想看的那一部。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-bold text-primary-950 transition-colors hover:bg-accent-400"
          >
            了解更多
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-lg bg-primary-900/70 p-6">
              <p className="font-heading text-3xl font-black text-accent-400 md:text-4xl">{s.value}</p>
              <p className="mt-2 text-sm text-background-300">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}